import { components } from '@/utils'

import { iMaskProps } from '@/components/g/input/mixins/iMask'

import { appearance, items, keyboard, menu, pointer, proxy, search, selectedItems, service, state } from './mixins'
import render from './render'

export default {
  name: components.select,

  mixins: [
    appearance,
    state,
    proxy,
    items,
    selectedItems,
    search,
    service,
    pointer,
    menu,
    keyboard
  ],

  props: { ...iMaskProps },

  async mounted() {
    this._fillSelectedItems()
    await this.findAll()
    this._setRequired()
  },

  render
}
